import React, { Component } from 'react';
import { general } from '../../data';

class Intro extends Component {
  constructor(){
    super();
  }

  createMarkup() {
    return {__html: this.props.text };
  }

  render() {
    let classes;
    if(this.props.challenge === 1){
      classes = 'gm-slide__intro-text gm-slide__intro-text--first-slide';
    } else {
      classes = 'gm-slide__intro-text';
    }

    return (
      <div>
        <img className="intro-image" src={this.props.image} />
        <p className={ classes } dangerouslySetInnerHTML={ this.createMarkup() } />
      </div>
    );
  }
}

export default Intro;



// WEBPACK FOOTER //
// ./src/components/Slides/Intro.js